// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ConfirmDialog - Ethereal Tech Design
 *
 * Features refined dialog styling with variant colors
 * and elegant button interactions.
 */

.confirm-dialog {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
}

.confirm-dialog-header {
  text-align: center;
}

.confirm-dialog-title {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--letter-spacing-tight);
  color: var(--text-primary);
}

.confirm-dialog-body {
  text-align: center;
}

.confirm-dialog-message {
  margin: 0;
  font-size: var(--font-size-base);
  color: var(--text-secondary);
  line-height: var(--line-height-relaxed);
}

.confirm-dialog-footer {
  display: flex;
  gap: var(--spacing-md);
  justify-content: center;
  padding-top: var(--spacing-sm);
}

.confirm-dialog-button {
  position: relative;
  padding: var(--spacing-sm) var(--spacing-xl);
  border: none;
  border-radius: var(--radius-lg);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--transition-base);
  min-width: 100px;
  overflow: hidden;
}

/* Button shine effect */
.confirm-dialog-button::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, transparent 50%);
  opacity: 0;
  transition: opacity var(--transition-fast);
}

.confirm-dialog-button:hover::before {
  opacity: 1;
}

/* Cancel button */
.confirm-dialog-button-cancel {
  background: var(--glass-bg);
  backdrop-filter: blur(var(--blur-sm));
  -webkit-backdrop-filter: blur(var(--blur-sm));
  color: var(--text-primary);
  border: 1px solid var(--glass-border);
}

.confirm-dialog-button-cancel:hover {
  background: var(--bg-hover);
  border-color: var(--glass-highlight);
}

/* Confirm button base */
.confirm-dialog-button-confirm {
  color: white;
}

/* Danger variant */
.confirm-dialog-button-danger {
  background: linear-gradient(135deg, var(--color-error), #dc2626);
  box-shadow: 0 4px 12px var(--color-error-glow);
}

.confirm-dialog-button-danger:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px var(--color-error-glow);
}

.confirm-dialog-button-danger:active {
  transform: translateY(0);
}

/* Warning variant */
.confirm-dialog-button-warning {
  background: linear-gradient(135deg, var(--color-warning), #d97706);
  box-shadow: 0 4px 12px var(--color-warning-glow);
}

.confirm-dialog-button-warning:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px var(--color-warning-glow);
}

.confirm-dialog-button-warning:active {
  transform: translateY(0);
}

/* Info variant */
.confirm-dialog-button-info {
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  box-shadow: 0 4px 12px var(--color-primary-glow);
}

.confirm-dialog-button-info:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px var(--color-primary-glow);
}

.confirm-dialog-button-info:active {
  transform: translateY(0);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .confirm-dialog {
    gap: var(--spacing-lg);
  }

  .confirm-dialog-footer {
    flex-direction: column-reverse;
  }

  .confirm-dialog-button {
    width: 100%;
    padding: var(--spacing-md);
  }
}
`, "",{"version":3,"sources":["webpack://./../../../../packages/apps/myagent/myagent_ui/src/components/ConfirmDialog.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAIF;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;EACxC,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,sCAAsC;EACtC,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kFAAkF;EAClF,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,6CAA6C;EAC7C,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,gEAAgE;EAChE,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,kEAAkE;EAClE,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,iFAAiF;EACjF,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,0BAA0B;EAC5B;AACF","sourcesContent":["/**\n * ConfirmDialog - Ethereal Tech Design\n *\n * Features refined dialog styling with variant colors\n * and elegant button interactions.\n */\n\n@import \"../styles/variables.css\";\n\n.confirm-dialog {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xl);\n}\n\n.confirm-dialog-header {\n  text-align: center;\n}\n\n.confirm-dialog-title {\n  margin: 0;\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  letter-spacing: var(--letter-spacing-tight);\n  color: var(--text-primary);\n}\n\n.confirm-dialog-body {\n  text-align: center;\n}\n\n.confirm-dialog-message {\n  margin: 0;\n  font-size: var(--font-size-base);\n  color: var(--text-secondary);\n  line-height: var(--line-height-relaxed);\n}\n\n.confirm-dialog-footer {\n  display: flex;\n  gap: var(--spacing-md);\n  justify-content: center;\n  padding-top: var(--spacing-sm);\n}\n\n.confirm-dialog-button {\n  position: relative;\n  padding: var(--spacing-sm) var(--spacing-xl);\n  border: none;\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all var(--transition-base);\n  min-width: 100px;\n  overflow: hidden;\n}\n\n/* Button shine effect */\n.confirm-dialog-button::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, transparent 50%);\n  opacity: 0;\n  transition: opacity var(--transition-fast);\n}\n\n.confirm-dialog-button:hover::before {\n  opacity: 1;\n}\n\n/* Cancel button */\n.confirm-dialog-button-cancel {\n  background: var(--glass-bg);\n  backdrop-filter: blur(var(--blur-sm));\n  -webkit-backdrop-filter: blur(var(--blur-sm));\n  color: var(--text-primary);\n  border: 1px solid var(--glass-border);\n}\n\n.confirm-dialog-button-cancel:hover {\n  background: var(--bg-hover);\n  border-color: var(--glass-highlight);\n}\n\n/* Confirm button base */\n.confirm-dialog-button-confirm {\n  color: white;\n}\n\n/* Danger variant */\n.confirm-dialog-button-danger {\n  background: linear-gradient(135deg, var(--color-error), #dc2626);\n  box-shadow: 0 4px 12px var(--color-error-glow);\n}\n\n.confirm-dialog-button-danger:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px var(--color-error-glow);\n}\n\n.confirm-dialog-button-danger:active {\n  transform: translateY(0);\n}\n\n/* Warning variant */\n.confirm-dialog-button-warning {\n  background: linear-gradient(135deg, var(--color-warning), #d97706);\n  box-shadow: 0 4px 12px var(--color-warning-glow);\n}\n\n.confirm-dialog-button-warning:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px var(--color-warning-glow);\n}\n\n.confirm-dialog-button-warning:active {\n  transform: translateY(0);\n}\n\n/* Info variant */\n.confirm-dialog-button-info {\n  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));\n  box-shadow: 0 4px 12px var(--color-primary-glow);\n}\n\n.confirm-dialog-button-info:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px var(--color-primary-glow);\n}\n\n.confirm-dialog-button-info:active {\n  transform: translateY(0);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .confirm-dialog {\n    gap: var(--spacing-lg);\n  }\n\n  .confirm-dialog-footer {\n    flex-direction: column-reverse;\n  }\n\n  .confirm-dialog-button {\n    width: 100%;\n    padding: var(--spacing-md);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
